import { action, computed, makeObservable, onBecomeObserved } from "mobx"

import { catchErrors, tokensApi } from "@src/shared/api"
import Collection from "@src/shared/classes/Collection/Collection"
import { loading } from "@src/shared/classes/utils/loading"

export class ScopesCollection extends loading(["load"], Collection<string>) {
  constructor() {
    super()
    makeObservable(this, {
      flatScopes: computed,
      groups: computed,
      load: action.bound,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async load() {
    try {
      const {
        data: { data },
      } = await tokensApi.getTokensScopes()

      if (data) {
        this.replace(data as string[])
      }
    } catch (e: any) {
      catchErrors(e)
    }
  }

  get flatScopes() {
    return Object.values(this.groups).flat()
  }

  get groups() {
    return this.items.reduce((acc: Record<string, string[]>, currentValue) => {
      const g = currentValue.split(".")[0]

      if (!g) {
        return acc
      }

      if (acc[g] && Array.isArray(acc[g])) {
        acc[g]?.push(currentValue)
      } else {
        acc[g] = [currentValue]
      }

      return acc
    }, {})
  }
}
